import axios from 'axios';

/**
 * Request for logged
 * @type object
 */
const promise = axios.create({
      headers: {
        'X-CSRF-TOKEN': Laravel.csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
    }
});

export default promise;




// WEBPACK FOOTER //
// ./resources/assets/js/app/utils/promise.js